/* eslint-disable import/prefer-default-export */
import React from 'react';

export const DispatchContext = React.createContext(null);

export const StateContext = React.createContext(null);
